import PortalIdParser from 'PortalIdParser';
import I18n from 'I18n';
import { DashworksAuthModal } from 'ui-universal-auth';
import { jsx as _jsx } from "react/jsx-runtime";
export const DashworksServiceComponent = ({
  metadata,
  onAuthCancelled,
  onAuthSucceeded,
  onAuthFailed,
  reconnectStarted
}) => {
  const portalId = PortalIdParser.get();
  const appId = metadata === null || metadata === void 0 ? void 0 : metadata.appId;
  const handleCancel = () => {
    onAuthCancelled === null || onAuthCancelled === void 0 || onAuthCancelled({
      message: I18n.text('reconnect.warnings.reconnectionCancelled')
    });
  };
  const handleError = args => {
    onAuthFailed === null || onAuthFailed === void 0 || onAuthFailed(args);
  };
  const handleComplete = secretId => {
    onAuthSucceeded === null || onAuthSucceeded === void 0 || onAuthSucceeded(secretId);
  };
  return reconnectStarted && /*#__PURE__*/_jsx(DashworksAuthModal, {
    appId: appId,
    portalId: portalId,
    onComplete: handleComplete,
    onCancel: handleCancel,
    onError: handleError
  });
};